import AddressSearchUtil from 'edge/addresslookup/util/AddressSearchUtil';
import AddressLookupService from 'edge/addresslookup/service/AddressLookupService';

export default angular.module('edge.addresslookup.app', [])
    .factory('addresslookup.AddressSearchUtil', AddressSearchUtil)
    .factory('addresslookup.AddressLookupService', AddressLookupService);
